// extracted by mini-css-extract-plugin
export default {"counterParent":"CountDown_counterParent__vFkwT"};